/** import custom dependency [start] */
import { getData, postData } from '../';
import URL from '../../utils/baseUrls';
import { PayloadTypes } from '../types';
/** import custom dependency [end] */

/**
 * Get the Endpoint details from the backend
 * @param endpointId Endpoint reference ID
 * @returns
 */
export const getEndpointDetailsData = async (endpointId: string) => {
    const res = await getData(URL.getEndpointDetailsUrl(endpointId));
    return res;
};

/**
 * Delete the Endpoint details form the backend
 * @param endpointId Endpoint reference ID
 * @returns
 */
export const deleteTheEndpoint = async (endpointId: string) => {
    const res = await getData(URL.deleteEndpointUrl(endpointId));
    return res;
};

/**
 * Update the Endpoint details on the backend
 * @param payload
 * @param type
 * @returns
 */
export const updateEndpointName = async (payload: PayloadTypes.UpdateEndpointNamePayload, type: string) => {
    const res = await postData(URL.getUpdateEndpointNameOrSecurityUrl(type), payload);
    return res;
};

/**
 * Update the Security details on the backend
 * @param payload
 * @param type
 * @returns
 */
export const updateSecurity = async (payload: PayloadTypes.UpdateSecurityPayload, type: string) => {
    const res = await postData(URL.getUpdateEndpointNameOrSecurityUrl(type), payload);
    return res;
};

/**
 * Get the API consumption and quota from the backend
 * @param subscriptionId Subsciption reference ID
 * @returns
 */
export const getEndpointConsumed = async (subscriptionId: string) => {
    const res = await getData(URL.getEndpointConsuptionUrl(subscriptionId));
    return res;
};

/**
 * Get the API summary data of an endpoint from the backend
 * @param endpointId Endpoint reference ID
 * @returns
 */
export const getSummaryData = async (endpointId: string) => {
    const res = await getData(URL.getEndpointMatricsUrl(endpointId));
    return res;
};

/**
 * Get the API Method calls data of an endpoint from the backend
 * @param endpointId Endpoint reference ID
 * @returns
 */
export const getMethodCallData = async (endpointId: string) => {
    const res = await getData(URL.getEndpointMethodCallUrl(endpointId));
    return res;
};


/**
 * Get the API Recent method list of an endpoint from the backend
 * @param endpointId Endpoint reference ID
 * @returns
 */
export const getRecentMethodData = async (endpointId: string) => {
    const res = await getData(URL.getEndpointRecentMethodCUrl(endpointId));
    return res;
};
